export default __webpack_public_path__ + "static/media/demo-chat.b18ba8f5.gif";